import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MailchimpService {
  // Use our backend endpoint instead of direct MailChimp API calls
  private subscribeUrl = '/api/subscribe';

  constructor(private http: HttpClient) { }

  // Subscribe a user to the MailChimp list through our backend
  subscribe(email: string, firstName?: string, lastName?: string): Observable<any> {
    const data = {
      email: email,
      firstName: firstName || '',
      lastName: lastName || ''
    };

    return this.http.post(this.subscribeUrl, data)
      .pipe(
        catchError(this.handleError)
      );
  }

  // Error handling
  private handleError(error: HttpErrorResponse) {
    console.error('MailChimp API error:', error);
    
    // Return an observable with a user-facing error message
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred
      console.error('An error occurred:', error.error.message);
      return throwError('A client-side error occurred. Please try again later.');
    } else {
      // The backend returned an unsuccessful response code
      console.error(`Backend returned code ${error.status}, body was:`, error.error);
      return throwError(error);
    }
  }
}